// 当前运营控制台源码维护说明，更新时间：2026-09-02 CST。积分和充值金额统一按三位小数 HALF_UP 展示。
export function displayText(value: unknown) {
  return value === undefined || value === null || value === '' ? '暂无数据' : String(value);
}

export function displayDateTime(value: unknown) {
  if (value === undefined || value === null || value === '') {
    return '暂无数据';
  }
  const textValue = String(value);
  const match = textValue.match(/^(\d{4}-\d{2}-\d{2})T(\d{2}:\d{2})/);
  if (match) {
    return `${match[1]} ${match[2]}`;
  }
  return textValue;
}

/**
 * HotX 金额展示统一入口。后端仍负责账务精度和入账事实，前端只做三位小数 HALF_UP 展示。
 */
export function displayThreeDecimal(value: unknown) {
  const normalized = normalizeDecimal(value);
  const match = normalized.match(/^([+-]?)(\d+)(?:\.(\d*))?$/);
  if (!match) {
    return '0.000';
  }

  const sign = match[1];
  const whole = match[2].replace(/^0+(?=\d)/, '') || '0';
  const fraction = `${match[3] || ''}0000`;
  let scaled = BigInt(whole) * 1000n + BigInt(fraction.slice(0, 3));
  if (Number(fraction.charAt(3)) >= 5) {
    scaled += 1n;
  }

  const prefix = sign === '-' && scaled !== 0n ? '-' : '';
  const integerPart = scaled / 1000n;
  const decimalPart = String(scaled % 1000n).padStart(3, '0');
  return `${prefix}${integerPart}.${decimalPart}`;
}

function normalizeDecimal(value: unknown) {
  if (value === undefined || value === null || value === '') {
    return '0';
  }
  const text = String(value).trim().replace(/,/g, '');
  if (!/[eE]/.test(text)) {
    return text;
  }
  const numeric = Number(text);
  if (!Number.isFinite(numeric)) {
    return '0';
  }
  return numeric.toFixed(12).replace(/0+$/, '').replace(/\.$/, '');
}
